import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { WorkCalenderRequest, WorkCalenderResponse } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { WorkCalenderDto } from "./dto/work-calender.dto";
import { WorkCalender } from "./entity/work-calender.entity";
import { WorkCalenderAdapter } from "./work-calender.adapter";

@Injectable()
export class WorkCalenderService {

    constructor(
        @InjectRepository(WorkCalender)
        private workcalenderRepository: Repository<WorkCalender>,
        private workcalenderAdapter: WorkCalenderAdapter,
    ){}

    async getWorkCalenderWithoutRelations(id: number): Promise<WorkCalender>{
        const workcalenderResponse = await  this.workcalenderRepository.findOne({
            where: {id: id},
        });
        if(workcalenderResponse){
            return workcalenderResponse;
        }else {
            return null;
        }
    }

    
    async createWorkCalender(workcalenderDTO: WorkCalenderDto, isUpdate: boolean): Promise<WorkCalenderResponse>{
        try{
            if(!isUpdate){
                const workcalenderEntity = await this.getWorkCalenderWithoutRelations(workcalenderDTO.id);
                if(workcalenderEntity){
                    throw new ErrorResponse(11104, 'Work Calender already exists');
                }
            }else {
                const workcalenderEntity = await this.getWorkCalenderWithoutRelations(workcalenderDTO.id);
                if(workcalenderEntity){
                    if(workcalenderEntity.id != workcalenderDTO.id){
                        throw new ErrorResponse(11104, 'Work Calender already exists')
                    }
                }
            }
            const convertedEntity: WorkCalender = this.workcalenderAdapter.convertDtoToEntity(workcalenderDTO, isUpdate);
            const savedEntity: WorkCalender = await this.workcalenderRepository.save(convertedEntity);
            const savedDto: WorkCalenderDto = this.workcalenderAdapter.convertEntityToDto(convertedEntity);
            if(savedDto){
                const response = new WorkCalenderResponse(true, 1, isUpdate? 'Work Calender Updated Successfully' : 'Work Calender Created Successfully');
                return response;
            }else{
                throw new ErrorResponse(11106, 'Work Calender saved but issue while transforming it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    
    async getAllWorkCalender() : Promise<WorkCalenderResponse>{
        try{
            const workcalenderDtos: WorkCalenderDto[] = [];
            const workcalenderEntities: WorkCalender[] = await this.workcalenderRepository.find({order: {id: 'ASC'}});
            if(workcalenderEntities){
                workcalenderEntities.forEach(Entity => {
                    const convertedDto: WorkCalender = this.workcalenderAdapter.convertEntityToDto(Entity);
                    workcalenderDtos.push(convertedDto);
                });
                const response = new WorkCalenderResponse(true, 1, 'Work Calender Retrieved Successfully', workcalenderDtos);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getAllActiveWorkCalender() : Promise<WorkCalenderResponse>{
        try{
            const workcalenderDtos: WorkCalenderDto[] = [];
            const workcalenderEntities: WorkCalender[] = await this.workcalenderRepository.find({order: {id: 'ASC'}, where: {isActive: true},});
            if(workcalenderEntities){
                workcalenderEntities.forEach(Entity => {
                    const convertedEntity: WorkCalender = this.workcalenderAdapter.convertEntityToDto(Entity);
                    workcalenderDtos.push(convertedEntity);
                });
                const response = new WorkCalenderResponse(true, 11108, 'Active Work Calender Retrieved Successfully', workcalenderDtos);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getWorkCalenderById(id: number): Promise<WorkCalender>{
        const response = await this.workcalenderRepository.findOne({
            where: {id: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateWorkCalender(workcalenderReq: WorkCalenderRequest): Promise<WorkCalenderResponse>{
        try{
            const workcalenderExists = await this.getWorkCalenderById(workcalenderReq.id);
            if(workcalenderExists){
                if(workcalenderReq.versionFlag != workcalenderExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current work calender information. Refresh and try again');
                }else{
                    const workcalenderStatus = await this.workcalenderRepository.update(
                        {id: workcalenderReq.id},
                        {isActive: workcalenderReq.isActive, updatedUser: workcalenderReq.updatedUser}
                    );
                    if(workcalenderExists.isActive){
                        if(workcalenderStatus.affected){
                            const workcalenderResponse: WorkCalenderResponse = new WorkCalenderResponse(true, 10115, 'work calender is de-activated successfully');
                            return workcalenderResponse;
                        }else{
                            throw new ErrorResponse(10111, 'work calender is already de-activated');
                        }
                    }else{
                        if(workcalenderStatus.affected){
                            const workcalenderResponse: WorkCalenderResponse = new WorkCalenderResponse(true, 10114, 'work calender is activated successfully');
                            return workcalenderResponse;
                        }else{
                            throw new ErrorResponse(10112, 'work calender is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(err){
            throw err;
        }
    }

}